/**
 * Card color switcher: updates grid product card via products/{handle}.js
 * when theme.settings.enableCardColorSwitch is true.
 */
(function () {
  if (!window.theme || !theme.settings || !theme.settings.enableCardColorSwitch) {
    return;
  }

  var productCache = new Map();

  window.ARK_CARD_DEBUG =
    window.ARK_CARD_DEBUG ||
    /[?&]ark_card_debug=1/.test(window.location.search);

  function arkCardDebug() {
    if (!window.ARK_CARD_DEBUG) return;
    var args = ['[ark-card-color]'].concat(
      Array.prototype.slice.call(arguments)
    );
    console.log.apply(console, args);
  }

  function getProductImageUrl(product, index) {
    if (!product) return '';
    var i = index || 0;
    if (product.images && product.images[i]) {
      var entry = product.images[i];
      if (typeof entry === 'string') return entry;
      if (entry.src) return entry.src;
      if (entry.url) return entry.url;
    }
    if (i === 0 && product.featured_image) {
      if (typeof product.featured_image === 'string') return product.featured_image;
      if (product.featured_image.src) return product.featured_image.src;
      if (product.featured_image.url) return product.featured_image.url;
    }
    return '';
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;');
  }

  function getProductImagesList(product) {
    var list = [];
    if (product.images && product.images.length) {
      product.images.forEach(function (entry) {
        var url =
          typeof entry === 'string' ? entry : entry && (entry.src || entry.url);
        if (url) list.push(url);
      });
    }
    if (!list.length) {
      var featured = getProductImageUrl(product, 0);
      if (featured) list.push(featured);
    }
    return list;
  }

  function eventTargetElement(evt) {
    if (!evt || !evt.target) return null;
    var target = evt.target;
    return target.nodeType === 1 ? target : target.parentElement || null;
  }

  function closestFromEvent(evt, selector) {
    var el = eventTargetElement(evt);
    return el && typeof el.closest === 'function' ? el.closest(selector) : null;
  }

  function productJsonUrl(handle) {
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      window.root_url ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'products/' + handle + '.js';
  }

  function stripCardTitle(title) {
    if (!title) return '';
    var path = window.location.pathname.toLowerCase();

    var shopLocale = window.Shopify && Shopify.locale ? String(Shopify.locale).toLowerCase() : '';
    var isDe =
      shopLocale.indexOf('de') === 0 ||
      /\/de-de|\/de-at|\/de-ch/.test(path) ||
      path.indexOf('/de') === 0;

    if (isDe) {
      return title
        .split(/\s+/)
        .map(function (word) {
          return word.replace(/^HUNDE/i, '');
        })
        .filter(function (word) {
          return word.length > 0;
        })
        .join(' ')
        .trim();
    }

    var patterns;

    if (path.indexOf('/it') !== -1) {
      patterns = [/PER CANE/gi, /PER CANI/gi];
    } else if (path.indexOf('/fr') !== -1) {
      patterns = [/POUR CHIENS/gi, /POUR CHIEN/gi];
    } else if (path.indexOf('/pt') !== -1) {
      patterns = [/PARA CÃES/gi, /PARA CÃO/gi, /PARA CAES/gi, /PARA CAO/gi];
    } else if (path.indexOf('/en') !== -1) {
      patterns = [/FOR DOGS/gi, /\bDOG\b/gi];
    } else {
      patterns = [/PARA PERROS/gi, /PARA PERRO/gi];
    }

    patterns.forEach(function (pattern) {
      title = title.replace(pattern, '');
    });
    return title.replace(/\s+/g, ' ').trim();
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function sizedImageUrl(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + width;
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) {
      return Promise.resolve(productCache.get(handle));
    }
    return fetch(productJsonUrl(handle))
      .then(function (res) {
        if (!res.ok) throw new Error('Product fetch failed');
        return res.json();
      })
      .then(function (data) {
        productCache.set(handle, data);
        return data;
      });
  }

  function updatePrice(card, product) {
    var priceContainer = card.querySelector(
      '.grid-product__link .grid-product__price'
    );
    if (!priceContainer) return;

    var onSale =
      product.compare_at_price && product.compare_at_price > product.price;
    var originalEl = priceContainer.querySelector('.grid-product__price--original');
    var priceEl = priceContainer.querySelector('.price');
    var savingsEl = priceContainer.querySelector('.grid-product__price--savings');

    if (originalEl) {
      if (onSale) {
        originalEl.innerHTML = formatMoney(product.compare_at_price);
        originalEl.classList.remove('hide');
      } else {
        originalEl.innerHTML = '';
        originalEl.classList.add('hide');
      }
    }

    if (priceEl) {
      if (product.price_varies) {
        var fromPrefix = (theme.strings && theme.strings.productFrom) || '';
        priceEl.innerHTML =
          fromPrefix + formatMoney(product.price_min);
      } else {
        priceEl.innerHTML = formatMoney(product.price);
      }
    }

    if (savingsEl && onSale && theme.settings.saveType) {
      var saved =
        theme.settings.saveType === 'dollar'
          ? product.compare_at_price - product.price
          : Math.round(
              ((product.compare_at_price - product.price) * 100) /
                product.compare_at_price
            );
      var savedLabel =
        theme.settings.saveType === 'dollar'
          ? formatMoney(saved)
          : saved + '%';
      if (theme.strings && theme.strings.savePrice) {
        savingsEl.innerHTML = theme.strings.savePrice.replace(
          '[saved_amount]',
          savedLabel
        );
        savingsEl.classList.remove('hide');
      }
    } else if (savingsEl) {
      savingsEl.classList.add('hide');
    }

    if (theme.settings.showDiscountPercentageTag) {
      var discountTag = card.querySelector('.grid-product_discount_tag');
      if (discountTag) {
        if (onSale && product.available !== false) {
          var percent = Math.round(
            ((product.compare_at_price - product.price) * 100) /
              product.compare_at_price
          );
          discountTag.textContent = '-' + percent + '%';
          discountTag.style.display = '';
        } else {
          discountTag.style.display = 'none';
        }
      }
    }
  }

  function cardHasColorCarousel(card) {
    return !!card.querySelector(
      '.ark-product-card-swiper[data-carousel-mode="colors"]'
    );
  }

  function cardHasMediaCarousel(card) {
    return !!card.querySelector(
      '.ark-product-card-swiper[data-carousel-mode="media"]'
    );
  }

  function captureMediaSlideTemplate(swiperEl) {
    var slide = swiperEl.querySelector('.swiper-slide');
    if (!slide) {
      return {
        wrapStyle: 'height: 0; padding-bottom: 133.33333333333334%;',
        imgClass: 'grid-product__image image-element featured-img',
      };
    }
    var wrap = slide.querySelector('.ark-card-swiper__wrap');
    var img = slide.querySelector('img');
    return {
      wrapStyle:
        (wrap && wrap.getAttribute('style')) ||
        'height: 0; padding-bottom: 133.33333333333334%;',
      imgClass:
        (img && img.className) ||
        'grid-product__image image-element featured-img',
    };
  }

  function buildMediaSlideHtml(product, imageUrl, index, template, allImages) {
    var title = escapeHtml(stripCardTitle(product.title));
    var productUrl = escapeHtml(product.url || '');
    var src = sizedImageUrl(imageUrl, 1080);
    var tpl = template || {};
    var wrapStyle =
      tpl.wrapStyle || 'height: 0; padding-bottom: 133.33333333333334%;';
    var imgClass =
      tpl.imgClass || 'grid-product__image image-element featured-img';

    return (
      '<div class="swiper-slide" data-media-index="' +
      index +
      '">' +
      '<a href="' +
      productUrl +
      '" class="ark-card-swiper__link" aria-label="' +
      title +
      '">' +
      '<div class="image-wrap ark-card-swiper__wrap loaded" style="' +
      wrapStyle +
      '">' +
      '<image-element class="featuredImgCont">' +
      '<img src="' +
      src +
      '" alt="' +
      title +
      '" loading="lazy" class="' +
      imgClass +
      '" />' +
      '</image-element>' +
      '</div></a></div>'
    );
  }

  function destroyArkCardSwiper(swiperEl) {
    if (!swiperEl) return;
    if (typeof window.__cleanupArkMediaCarouselHover === 'function') {
      window.__cleanupArkMediaCarouselHover(swiperEl);
    }
    var instance = swiperEl.swiper;
    if (instance && !instance.destroyed) {
      try {
        instance.destroy(true, true);
      } catch (err) {
        try {
          instance.destroy();
        } catch (err2) {}
      }
    }
    delete swiperEl.dataset.swiperInitialized;
    swiperEl.classList.remove(
      'swiper-initialized',
      'swiper-horizontal',
      'swiper-vertical',
      'swiper-backface-hidden'
    );
  }

  function syncMediaCarouselAfterCardUpdate(card, product) {
    var swiperEl = card.querySelector(
      '.ark-product-card-swiper[data-carousel-mode="media"]'
    );
    if (!swiperEl || !product) return;

    var images = getProductImagesList(product);
    if (!images.length) {
      arkCardDebug('media carousel: no images', product.handle);
      return;
    }

    var maxFromAttr = parseInt(swiperEl.getAttribute('data-max-slides'), 10);
    if (!isNaN(maxFromAttr) && maxFromAttr > 0) {
      images = images.slice(0, maxFromAttr);
    }

    var template = captureMediaSlideTemplate(swiperEl);
    arkCardDebug('rebuild media carousel', product.handle, images.length, 'slides');

    destroyArkCardSwiper(swiperEl);

    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var html = '';
    images.forEach(function (imageUrl, index) {
      html += buildMediaSlideHtml(product, imageUrl, index, template, images);
    });
    wrapper.innerHTML = html;
    swiperEl.setAttribute('data-initial-slide', '0');

    if (typeof window.__initSingleArkProductCardSwiper === 'function') {
      window.__initSingleArkProductCardSwiper(swiperEl);
    }

    var instance = swiperEl.swiper;
    if (instance && !instance.destroyed) {
      instance.slideTo(0, 0);
      if (typeof instance.update === 'function') instance.update();
    }
  }

  function updateSlideImages(slide, product) {
    if (!slide || !product) return false;

    var imageUrl = getProductImageUrl(product, 0);
    if (!imageUrl) {
      arkCardDebug('no image url for', product.handle);
      return false;
    }

    var mainSrc = sizedImageUrl(imageUrl, 400);
    var title = stripCardTitle(product.title);
    var imgs = slide.querySelectorAll('img');

    if (!imgs.length) {
      arkCardDebug('no img in slide', product.handle, slide);
      return false;
    }

    imgs.forEach(function (img, index) {
      if (index > 0 && img.closest('.grid-product__secondary-image')) return;
      img.src = mainSrc;
      img.removeAttribute('srcset');
      img.removeAttribute('data-src');
      img.alt = title;
    });

    var secondaryUrl = getProductImageUrl(product, 1);
    var secondaryWrap = slide.querySelector('.grid-product__secondary-image');
    if (secondaryWrap && secondaryUrl) {
      var secondaryImg = secondaryWrap.querySelector('img');
      if (secondaryImg) {
        secondaryImg.src = sizedImageUrl(secondaryUrl, 400);
        secondaryImg.removeAttribute('srcset');
        secondaryImg.removeAttribute('data-src');
      }
    }

    var slideLink = slide.querySelector('.ark-card-swiper__link');
    if (slideLink && product.url) slideLink.href = product.url;
    if (product.url) slide.setAttribute('data-product-url', product.url);

    arkCardDebug('slide images updated', product.handle, mainSrc);
    return true;
  }

  function clearColorImageOverlays(card) {
    card.querySelectorAll('.grid-product__color-image.is-active').forEach(function (el) {
      el.classList.remove('is-active');
      el.style.backgroundImage = '';
    });
  }

  function refreshActiveCarouselSlide(swiperEl, product) {
    var instance = swiperEl.swiper;
    if (!instance || instance.destroyed || !instance.slides) return;

    var active = instance.slides[instance.activeIndex];
    if (active) updateSlideImages(active, product);
    if (typeof instance.update === 'function') instance.update();
    arkCardDebug('active index', instance.activeIndex, 'handle', product.handle);
  }

  function syncColorCarouselAfterCardUpdate(card, product) {
    if (!card || !product || !cardHasColorCarousel(card)) return;

    var swiperEl = card.querySelector(
      '.ark-product-card-swiper[data-carousel-mode="colors"]'
    );
    if (!swiperEl) return;

    arkCardDebug('sync colors carousel start', product.handle);

    swiperEl.querySelectorAll('.swiper-slide').forEach(function (slide) {
      if (slide.getAttribute('data-product-handle') === product.handle) {
        updateSlideImages(slide, product);
      }
    });

    var afterSlide = function () {
      refreshActiveCarouselSlide(swiperEl, product);
    };

    if (typeof window.slideArkProductCardSwiperToHandle === 'function') {
      var slid = window.slideArkProductCardSwiperToHandle(swiperEl, product.handle, {
        suppressMetaDispatch: true,
        onComplete: afterSlide,
      });

      if (!slid) {
        arkCardDebug('slideTo failed — updating visible slide from JSON', product.handle);
        if (typeof window.__initSingleArkProductCardSwiper === 'function') {
          window.__initSingleArkProductCardSwiper(swiperEl);
        }
        afterSlide();
        var fallback = swiperEl.querySelector('.swiper-slide');
        if (fallback) updateSlideImages(fallback, product);
      }
      return;
    }

    var fallbackSlide =
      swiperEl.querySelector(
        '.swiper-slide[data-product-handle="' + product.handle + '"]'
      ) || swiperEl.querySelector('.swiper-slide');
    if (fallbackSlide) updateSlideImages(fallbackSlide, product);
  }

  function updateImage(card, product) {
    clearColorImageOverlays(card);

    if (cardHasColorCarousel(card)) {
      syncColorCarouselAfterCardUpdate(card, product);
      return;
    }

    if (cardHasMediaCarousel(card)) {
      syncMediaCarouselAfterCardUpdate(card, product);
      return;
    }

    var imageUrl = getProductImageUrl(product, 0);
    if (!imageUrl) return;

    var mainSrc = sizedImageUrl(imageUrl, 400);
    var title = stripCardTitle(product.title);

    card
      .querySelectorAll(
        '.grid-product__image-mask img.featured-img, .grid-product__image-mask img.image-element, .grid-product__image-mask .grid-product__image'
      )
      .forEach(function (img) {
        if (img.closest('.ark-product-card-swiper')) return;
        img.src = mainSrc;
        img.removeAttribute('srcset');
        img.alt = title;
      });

    var secondaryWrap = null;
    card
      .querySelectorAll('.grid-product__image-mask .grid-product__secondary-image')
      .forEach(function (wrap) {
        if (!secondaryWrap && !wrap.closest('.ark-product-card-swiper')) {
          secondaryWrap = wrap;
        }
      });
    var secondaryUrl = getProductImageUrl(product, 1);
    if (secondaryWrap && secondaryUrl) {
      var secondaryImg = secondaryWrap.querySelector('img');
      if (secondaryImg) {
        secondaryImg.src = sizedImageUrl(secondaryUrl, 400);
        secondaryImg.removeAttribute('srcset');
        secondaryImg.removeAttribute('data-src');
      }
    }
  }

  function setSwatchSelection(wrapper, activeSwatch) {
    if (!wrapper || !activeSwatch) return;

    wrapper.querySelectorAll('.ark-color-switcher--ajax').forEach(function (el) {
      var isActive = el === activeSwatch;
      el.classList.toggle('selected', isActive);
      if (isActive) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }

  function findSwatchForProduct(wrapper, product) {
    var swatches = wrapper.querySelectorAll('.ark-color-switcher--ajax');
    if (!swatches.length) return null;

    var match = null;
    swatches.forEach(function (el) {
      if (match) return;
      if (el.getAttribute('data-handle') === product.handle) match = el;
      if (String(el.getAttribute('data-product-id')) === String(product.id)) match = el;
    });

    return match || swatches[0];
  }

  function findSwatchForCard(wrapper, card) {
    var handle = card.getAttribute('data-product-handle');
    var id = card.getAttribute('data-product-id');
    var swatches = wrapper.querySelectorAll('.ark-color-switcher--ajax');
    if (!swatches.length) return null;

    var match = null;
    swatches.forEach(function (el) {
      if (match) return;
      if (handle && el.getAttribute('data-handle') === handle) match = el;
      if (id && String(el.getAttribute('data-product-id')) === String(id)) match = el;
    });

    return match || swatches[0];
  }

  function ensureDefaultSelected(card) {
    var wrapper = card.querySelector('.color_swatches_wrapper.col-grid');
    if (!wrapper) return;

    var swatch = findSwatchForCard(wrapper, card);
    if (swatch) setSwatchSelection(wrapper, swatch);
  }

  function initAllCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.grid-product').forEach(function (card) {
      ensureDefaultSelected(card);
      bindSwatchPrefetch(card.querySelector('.color_swatches_wrapper.col-grid'));
    });
  }

  function updateCard(card, product, activeSwatch) {
    card.setAttribute('data-product-handle', product.handle);
    card.setAttribute('data-product-id', product.id);

    var link = card.querySelector('.grid-product__link');
    if (link) link.href = product.url;

    var titleEl = card.querySelector('.grid-product__title');
    if (titleEl) titleEl.textContent = stripCardTitle(product.title);

    updatePrice(card, product);
    updateImage(card, product);

    var wrapper = card.querySelector('.color_swatches_wrapper');
    if (wrapper) {
      var swatch =
        activeSwatch || findSwatchForProduct(wrapper, product);
      setSwatchSelection(wrapper, swatch);
    }

    var quickBtn = card.querySelector('.quick-product__btn');
    if (quickBtn) {
      quickBtn.className = quickBtn.className.replace(
        /js-modal-open-quick-modal-\d+/,
        'js-modal-open-quick-modal-' + product.id
      );
    }
  }

  function setLoading(card, isLoading) {
    card.classList.toggle('ark-card-color-switch--loading', isLoading);
  }

  function findSwatchForHandle(wrapper, handle) {
    if (!wrapper || !handle) return null;
    var match = null;
    wrapper.querySelectorAll('.ark-color-switcher--ajax').forEach(function (el) {
      if (el.getAttribute('data-handle') === handle) match = el;
    });
    return match;
  }

  function updateCardMetaFromHandle(card, handle, activeSwatch) {
    if (!card || !handle) return Promise.resolve();

    if (card.getAttribute('data-product-handle') === handle) {
      var wrapper = card.querySelector('.color_swatches_wrapper');
      var swatch = activeSwatch || findSwatchForHandle(wrapper, handle);
      if (wrapper && swatch) setSwatchSelection(wrapper, swatch);
      return Promise.resolve();
    }

    setLoading(card, true);
    return fetchProduct(handle)
      .then(function (product) {
        arkCardDebug('fetched', handle, product && product.id);
        updateCard(card, product, activeSwatch);
      })
      .catch(function () {})
      .finally(function () {
        setLoading(card, false);
      });
  }

  function getAjaxSwatch(evt) {
    return closestFromEvent(
      evt,
      '.color_swatches_wrapper.col-grid .ark-color-switcher--ajax'
    );
  }

  function bindSwatchPrefetch(wrapper) {
    if (!wrapper || wrapper.dataset.arkPrefetchBound === 'true') return;
    wrapper.dataset.arkPrefetchBound = 'true';

    wrapper
      .querySelectorAll('.ark-color-switcher--ajax[data-handle]')
      .forEach(function (el) {
        if (el.classList.contains('selected')) return;

        var onIntent = function () {
          var handle = el.getAttribute('data-handle');
          if (handle) fetchProduct(handle).catch(function () {});
        };

        el.addEventListener('mouseenter', onIntent, { passive: true, once: true });
        el.addEventListener('touchstart', onIntent, { passive: true, once: true });
      });
  }

  function blockSwatchNavigation(evt) {
    var swatch = getAjaxSwatch(evt);
    if (!swatch) return;
    evt.preventDefault();
    evt.stopPropagation();
  }

  function slideColorCarouselToHandle(card, handle) {
    if (
      !cardHasColorCarousel(card) ||
      typeof window.slideArkProductCardSwiperToHandle !== 'function'
    ) {
      return;
    }
    var swiperEl = card.querySelector(
      '.ark-product-card-swiper[data-carousel-mode="colors"]'
    );
    if (swiperEl) {
      window.slideArkProductCardSwiperToHandle(swiperEl, handle, {
        suppressMetaDispatch: true,
      });
    }
  }

  function handleSwatchActivate(evt) {
    var swatch = getAjaxSwatch(evt);
    if (!swatch) return;

    evt.preventDefault();
    evt.stopPropagation();

    var card = swatch.closest('.grid-product');
    if (!card) return;

    var handle = swatch.getAttribute('data-handle');
    if (!handle) return;

    var cardHandle = card.getAttribute('data-product-handle');

    if (cardHandle === handle) {
      slideColorCarouselToHandle(card, handle);
      var wrapper = card.querySelector('.color_swatches_wrapper');
      if (wrapper) setSwatchSelection(wrapper, swatch);
      return;
    }

    updateCardMetaFromHandle(card, handle, swatch).catch(function () {
      var url = swatch.getAttribute('data-color-switch-url');
      if (url) window.location.href = url;
    });
  }

  /* Block any navigation from swatch href (click, middle-click, modified click) */
  ['click', 'auxclick', 'keydown'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (evt) {
        var swatch = getAjaxSwatch(evt);
        if (!swatch) return;

        if (eventName === 'keydown') {
          if (evt.key !== 'Enter' && evt.key !== ' ') return;
          handleSwatchActivate(evt);
          return;
        }

        if (eventName === 'auxclick' || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
          blockSwatchNavigation(evt);
          return;
        }

        handleSwatchActivate(evt);
      },
      true
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCards);
  } else {
    initAllCards();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAllCards(evt.target);
  });

  document.addEventListener('ark:card-swiper:change', function (evt) {
    if (!evt.detail || !evt.detail.card || !evt.detail.handle) return;
    if (!theme.settings.enableCardColorSwitch) return;

    var card = evt.detail.card;
    var handle = evt.detail.handle;

    if (card.getAttribute('data-product-handle') === handle) {
      var wrapper = card.querySelector('.color_swatches_wrapper');
      var swatch = findSwatchForHandle(wrapper, handle);
      if (wrapper && swatch) setSwatchSelection(wrapper, swatch);
      return;
    }

    var wrapper = card.querySelector('.color_swatches_wrapper');
    var swatch = findSwatchForHandle(wrapper, handle);

    updateCardMetaFromHandle(card, handle, swatch);
  });
})();

